<template>
  <div style="height: calc(100vh - 196px)">
    <vxe-toolbar
      id="toolbarId_bc16"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter"> 查询 </el-button>
        <el-button v-if="!parentData.isDetail" @click="funcAdd">
          新增
        </el-button>
        <el-button @click="funcExport"> 导出 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      :cell-class-name="cellClassName"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="authStatusExt"
          title="审核状态"
          :formatter="formatterAuthStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="owner"
          title="车主姓名"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.owner" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="licenseNumber"
          title="车辆牌照号"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="vehicleLicenseColor"
          title="车牌颜色"
          :formatter="formatterVehicleLicenseColor"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLicenseColor"
            placeholder="请选择车牌颜色"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleLicenseColorList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="locationSource"
          title="定位来源"
          :formatter="formatterLocationSource"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.locationSource"
            placeholder="请选择定位来源"
            clearable
          >
            <el-option
              v-for="item in parentData.locationSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="classificationCode"
          title="车型"
          :formatter="formatterClassificationCode"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择车型"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="240"
          field="length"
          title="车长(mm)"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.lengthStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.lengthEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="240"
          field="loadWeight"
          title="核定载质量/准牵引总质量(Kg)"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="240"
          field="totalWeight"
          title="总质量/挂车车头整备质量(Kg)"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="netStatus"
          title="入网标志"
          :formatter="formatterNetStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.netStatus"
            placeholder="请选择入网标志"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          min-width="420"
          title="车辆行驶证到期日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.issueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          min-width="420"
          title="道路运输证到期日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.issueDateRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="
              (value) => changeDate(value, 'roadTransportCertificateDate')
            "
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          min-width="420"
          title="注册时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="!parentData.isDetail"
        title="操作"
        width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <template>
            <el-tooltip
              v-if="scope.row.isFreeze === 0"
              class="item"
              effect="dark"
              content="冻结"
              placement="top"
            >
              <vxe-button type="text" @click="funcLock(scope.row.code)">
                <i class="el-icon-lock" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              content="解冻"
              placement="top"
            >
              <vxe-button type="text" @click="funcUnlock(scope.row.code)">
                <i class="el-icon-unlock" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="1400"
      height="800"
      resize
    >
      <compAdd
        ref="addRef"
        :parent-data="parentData"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="1400"
      height="800"
      resize
    >
      <compEdit
        ref="editRef"
        :parent-data="parentData"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/teamVehicleAdd";
import compEdit from "./components/teamVehicleEdit";
import {
  getBindList,
  delVehicle,
  freezeVehicle,
  unfreezeVehicle,
} from "@/api/driver";
export default {
  name: "TeamVehicleList",
  components: {
    compAdd,
    compEdit,
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleBindList: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          locationSourceList: [],
          vehicleLicenseColorList: [],
        };
      },
    },
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicle/exportBindList", //导出接口
        name: "车队车辆",
      },
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        issueDateRange: "",
        issueDateRange1: "",
        teamCode: "",
        owner: "",
        licenseNumber: "",
        vehicleLicenseColor: "",
        locationSource: "",
        classificationCode: "",
        length: "",
        loadWeight: "",
        totalWeight: "",
        netStatus: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        issueDate: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        branchCodeExt: this.$store.state.user.party.branchCode,
      },
      roadPermitNumber: "",
      roadPermitNumberImg: "",
      code: "",
      radioOptions: [
        { label: "有", value: 1 },
        { label: "无", value: 0 },
      ],
      authStatusOptions: [
        { label: "未审核", value: 0, color: "gray" },
        // { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" },
      ],
    };
  },
  created() {
    this.listQuery.teamCode = this.$route.query.partyCode || "";
    // this.findList();
  },
  methods: {
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ""));
    },
    findList() {
      this.loading = true;
      var data = Object.assign({}, this.listQuery, {
        teamCode: this.listQuery.teamCode,
      });
      return new Promise((resolve) => {
        getBindList(data).then((response) => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    funcAdd() {
      this.modelAddFlag = true;
      this.$refs.addRef.close();
    },
    funcEdit(code) {
      this.$nextTick(() => {
        this.$refs.editRef.getInfo(code);
      });
      this.modelEditFlag = true;
    },
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then((_) => {
          delVehicle({ codes }).then((response) => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch((_) => {});
    },
    funcLock(code) {
      this.$confirm("确认冻结吗？")
        .then((_) => {
          freezeVehicle({ code }).then((response) => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch((_) => {});
    },
    funcUnlock(code) {
      this.$confirm("确认解冻吗？")
        .then((_) => {
          unfreezeVehicle({ code }).then((response) => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch((_) => {});
    },
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //道路运输证
      if (column.property === "roadTransportCertificateDate") {
        if (
          row.roadTransportCertificateDate &&
          this.$XEUtils.timestamp(row.roadTransportCertificateDate) <=
            new Date().setMonth(new Date().getMonth() + 1)
        ) {
          return "col-red";
        } else if (row.age === 26) {
          return "col-orange";
        }
      }
      //车辆行驶证到期日期
      if (column.property === "vehicleLicenseDueDate") {
        if (
          row.vehicleLicenseDueDate &&
          this.$XEUtils.timestamp(row.vehicleLicenseDueDate) <=
            new Date().setMonth(new Date().getMonth() + 1)
        ) {
          return "col-red";
        } else if (row.age === 26) {
          return "col-orange";
        }
      }
    },
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        (item) => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterLocationSource({ cellValue }) {
      const item = this.parentData.locationSourceList.find(
        (item) => item.code === cellValue.toString()
      );
      return item ? item.name : "";
    },
    formatterVehicleLicenseColor({ cellValue }) {
      const item = this.parentData.vehicleLicenseColorList.find(
        (item) => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterClassificationCode({ cellValue }) {
      const item = this.parentData.vehicleClassificationList.find(
        (item) => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterNetStatus({ cellValue }) {
      const item = this.radioOptions.find((item) => item.value === cellValue);
      return item ? item.label : "";
    },
    changeStartDate(value) {
      this.listQuery.gmtCreatedStart = value + " 00:00:00";
    },
    changeEndDate(value) {
      this.listQuery.gmtCreatedEnd = value + " 23:59:59";
    },
  },
};
</script>

<style>
.mytable-style .vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
